import { CEMITERIOS } from "@/data/products";
import { MapPin } from "lucide-react";

// Faixa horizontal animada com nomes de cemitérios — prova social passiva de cobertura.
export const Marquee = () => {
  const items = [...CEMITERIOS, ...CEMITERIOS]; // duplica para loop suave
  return (
    <section aria-label="Cemitérios atendidos" className="relative bg-white border-y border-[#E5E3DB] overflow-hidden">
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      <div className="flex gap-10 py-5 marquee-track whitespace-nowrap">
        {items.map((c, i) => (
          <span key={i} className="inline-flex items-center gap-2 text-[13px] text-[#1C1C1C]/80 flex-shrink-0">
            <MapPin className="h-3.5 w-3.5 text-[#BFA573]" strokeWidth={1.5} />
            <span>{c}</span>
            <span className="text-[#BFA573] ml-6">·</span>
          </span>
        ))}
      </div>
    </section>
  );
};
